export default __webpack_public_path__ + "static/media/icon-shipping.a374d3ed.svg";